import styled from 'styled-components';
import { SelectTitle } from 'components/ui/Select';

const InputTitle = styled(SelectTitle)`
  text-align: ${(p: { centered?: boolean }) => (p.centered === true ? 'center' : 'left')};
  width: ${p => (p.centered === true ? '100%' : 'auto')};
`;

export default InputTitle;
